<template>
  <div class="back-top display-none" @click='backTop()'>
      <span class="iconfont icon-jiantou-copy-copy"></span>
  </div>
</template>

<script>
  export default {
  	data(){
  		return{

  		}
  	},
    methods:{
      showOrHide(){
        var sTop = $(window).scrollTop();
        if (sTop > 150) {
            $(".back-top").fadeIn();
        } else {
            $(".back-top").fadeOut();
        }
      },
      // 点击返回顶部的时候返回顶部
      backTop(){
        $('html,body').animate({scrollTop:0},500);
        return false;
      }
    },
    mounted(){
      window.addEventListener('scroll',this.showOrHide); // 监听滚动条高度，加载函数
    }
  }
</script>

<style scoped lang="scss">
@import  "../../sass/mixin";

.back-top{
	  position: fixed;
    right: 7%;
    bottom: 7%;
    width: 0.45rem;
    height: 0.45rem;
    background:rgba(34,34,34,0.8);
    text-align: center;
    line-height: 0.45rem;
    color: #fcd051;
    border-radius: 0.03rem;
    z-index: 90;

    span{
      font-size: .16rem;
    	vertical-align: 2px;
    }
}
.display-none{
  display: none;
}
</style>



// WEBPACK FOOTER //
// backTop.vue?8f58f4cc